/**
 * Deduplicación NF inventario gestión:
 * - Misma llave de acceso (NF-e) → duplicado global
 * - Mismo nro_nf + id_proveedor → duplicado por proveedor
 */

function safe(s) {
  return s == null ? '' : String(s);
}

export function normLlave(llave) {
  return safe(llave).replace(/\s+/g, '').trim();
}

export function parseNroNf(nro) {
  if (nro == null || nro === '') return null;
  const n = Number(String(nro).replace(/,/g, '.').trim());
  if (!Number.isFinite(n)) return null;
  return Math.round(n);
}

/** Clave nro_nf + proveedor (siempre indexada si hay datos). */
export function provNfKey(nota) {
  const prov = nota?.id_proveedor;
  const nro = parseNroNf(nota?.nro_nf);
  if (prov != null && prov !== '' && nro != null) {
    return `prov_nf:${prov}:${nro}`;
  }
  return null;
}

/** Clave de identidad principal (prioriza llave). */
export function nfIdentityKey(nota) {
  const llave = normLlave(nota?.llave);
  if (llave) return `llave:${llave}`;
  return provNfKey(nota);
}

export function nroNfLabel(nota) {
  const nro = nota?.nro_nf;
  if (nro != null && String(nro).trim() !== '') return String(nro).trim();
  return null;
}

/**
 * Filtra notas nuevas contra existentes (guardadas + preview previo).
 * @returns {{ aceptadas: object[], duplicados: string[] }}
 */
export function filtrarNotasDuplicadas(nuevas, existentes) {
  const existLlaves = new Set();
  const existProvNf = new Set();

  for (const n of existentes || []) {
    const l = normLlave(n.llave);
    if (l) existLlaves.add(l);
    const pk = provNfKey(n);
    if (pk) existProvNf.add(pk);
  }

  const aceptadas = [];
  const duplicados = [];
  const seenBatchLlaves = new Set();
  const seenBatchProvNf = new Set();

  for (const n of nuevas || []) {
    const llave = normLlave(n.llave);
    const pk = provNfKey(n);
    let reason = null;

    if (llave && existLlaves.has(llave)) reason = 'llave';
    else if (llave && seenBatchLlaves.has(llave)) reason = 'batch';
    else if (pk && seenBatchProvNf.has(pk)) reason = 'batch';
    else if (pk && existProvNf.has(pk)) reason = 'prov_nf';

    if (reason) {
      duplicados.push(duplicateMessage(n, reason));
      continue;
    }

    if (llave) seenBatchLlaves.add(llave);
    if (pk) seenBatchProvNf.add(pk);
    if (llave) existLlaves.add(llave);
    if (pk) existProvNf.add(pk);
    aceptadas.push(n);
  }

  return { aceptadas, duplicados };
}

export function duplicateMessage(nota, reason) {
  const nro = nroNfLabel(nota) || '(sin número)';
  if (reason === 'llave') return `NF ${nro}: llave de acceso ya registrada`;
  if (reason === 'batch') return `NF ${nro}: duplicada en la misma carga`;
  return `NF ${nro}: ya registrada para este proveedor`;
}

/** Texto resumen para toast / alerta de preview. */
export function mensajeDuplicados(duplicados) {
  const list = (duplicados || []).filter(Boolean);
  if (!list.length) return '';

  const numeros = [
    ...new Set(
      list
        .map((msg) => {
          const m = String(msg).match(/^NF\s+([^:]+):/);
          return m ? m[1].trim() : null;
        })
        .filter((n) => n && n !== '(sin número)')
    ),
  ];

  const head =
    list.length === 1
      ? '1 NF duplicada no se agregó'
      : `${list.length} NF duplicadas no se agregarán`;

  if (numeros.length) {
    return `${head} (N° ${numeros.join(', ')}). No se considerarán en la vista previa.`;
  }
  return `${head}. No se considerarán en la vista previa.`;
}
